<template>
<div class="card">
    <div class="card-header">{{title}}</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="24" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>      
                <b-col cols="12" lg="12">
                    <BaseTextOutput :label="title" :value="request.pcnUpdateComment"/>
                </b-col>
            </b-row>
            
            <b-row>                
                <b-col cols="12">
                    <b-button type="submit" variant="primary">Complete</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, decimal, numeric, minValue, maxValue, requiredUnless } from 'vuelidate/lib/validators'
import _ from "lodash"
import { commonOptions } from '@/mixins/commonOptions.js'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'

export default {
    components: {
        LifecycleCheckList
    },

    mixins: [
       commonOptions
    ], 
    
    props: {
        request: Object
    },
    
    data() {
        return { 
            saveOnly: false,
            checklistComplete: false,
        }
    },

     validations() {
        return {
            request: { 
                checklistComplete: { checked: value => value === true },
            }
        }
     },

    computed: { 
        title() {
            if (this.request.transactionQueueStatus === 2) {
                return "Update Position Control Number (PCN)"
            } else {
                return "Adjust Probation"
            }
        }
    },
    
    created() { },
    
    methods: {       
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        
        onSubmit() {
            this.$refs.checklist.emitCheckListStatus()
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }
            
            let payload = {
                requestId: this.request.id
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/pcnupdate/complete`, payload)
                  .then(response => {                       
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home')
                  })
                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>